module.exports = __webpack_public_path__ + "img/admin-bg.838119b9.jpg";